import {setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils.ts'
import {UIHeaderProfileController} from './UIHeaderProfileController.ts'
import {UICoinsController} from '../../../../shared/scripts/ui_coins/UICoinsController.ts'
import {UIHeaderController} from '../../../../shared/scripts/ui_html/header/UIHeaderController.ts'
import {removeURLParams} from '../../../../shared/scripts/ui_utils/Utils.ts'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'
import {stripOAuthTokenFromUrl} from '../../../../shared/scripts/ui_utils/TestableClientUtils.ts'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables.ts'

type MenuState = 'closed' | 'open'

export class UIWHeaderController extends UIHeaderController {
    private readonly header: HTMLDivElement

    readonly headerProfileController: UIHeaderProfileController

    private readonly hamburgerLeft: HTMLDivElement
    private readonly sidebarAndMenuOverlay: HTMLDivElement
    private readonly sidebarAndMenu: HTMLDivElement
    private sidebarAndMenuState: MenuState = 'closed'

    private readonly logoButton: HTMLDivElement
    private logoClickCallback?: () => void

    constructor() {
        super()

        this.header = document.getElementById('web-header') as HTMLDivElement

        // TODO: Muhammad - restyle left hamburger
        this.hamburgerLeft = document.getElementById('header-element-hamburger-left') as HTMLDivElement
        // TODO: Muhammad - cleanup styles
        this.sidebarAndMenuOverlay = document.getElementById('web-sidebar-and-menu-overlay') as HTMLDivElement
        this.sidebarAndMenu = document.getElementById('web-sidebar-and-menu') as HTMLDivElement

        this.logoButton = document.getElementById('web-header-logo') as HTMLDivElement

        this.headerProfileController = new UIHeaderProfileController()

        this.initLogoClick()
        this.initSidebarDrawer()

        new UICoinsController()

        stripOAuthTokenFromUrl()
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams()
    }

    hide() {
        this.header.classList.add('hidden')
    }

    show() {
        this.header.classList.remove('hidden')
    }

    private initLogoClick() {
        setElementOnClick(this.logoButton, () => {
            if(this.logoClickCallback) {
                this.logoClickCallback()
            }
        })
    }

    setLogoClickCallback(callback: () => void) {
        this.logoClickCallback = callback
    }

    private initSidebarDrawer() {
        setElementOnClick(this.hamburgerLeft, () => this.openSidebarAndMenu())
        setElementOnClick(this.sidebarAndMenuOverlay, () => this.closeSidebarAndMenu())
    }

    private openSidebarAndMenu() {
        if(this.sidebarAndMenuState == 'open') return
        this.sidebarAndMenu.classList.add('open')
        this.sidebarAndMenuOverlay.classList.remove('hidden')
        this.sidebarAndMenuState = 'open'
    }

    closeSidebarAndMenu() {
        if(this.sidebarAndMenuState == 'closed') return
        this.sidebarAndMenu.classList.remove('open')
        this.sidebarAndMenuOverlay.classList.add('hidden')
        this.sidebarAndMenuState = 'closed'
    }

    protected setupShuffleLinkInterceptor() {
        const notificationPanelContent = this.notificationPanelController.notificationPanelContent

        const shuffleLinks = notificationPanelContent.querySelectorAll('a[href*="#matchmakingqueue=16"]') as NodeListOf<HTMLLinkElement>

        shuffleLinks.forEach((link) => {
            if(link.hasAttribute('data-shuffle-handler')) return
            link.setAttribute('data-shuffle-handler', 'true')

            // eslint-disable-next-line no-restricted-syntax
            link.addEventListener('click', async(event) => {
                event.preventDefault()
                await UIWHeaderController.sendPlayNowClickAnalytic()
                if(!UIUtilsEjsVariables.isUserOnDiscord) window.location.href = link.href
            })
        })
    }

    private static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('login-popup')) return

        new ViewPopupLogin()
        removeURLParams()
    }
}
